import { DesignUpdateFavoriteAction, DesignsActionTypes } from '../types';

export const updateDesignFavoriteAction = (
  deprecatedDesignId: string,
  designId: string
): DesignUpdateFavoriteAction => ({
  type: DesignsActionTypes.UPDATE_FAVORITE,
  deprecatedDesignId,
  designId,
});
